// extracted by mini-css-extract-plugin
export default {"trainingPrograms":"trainingPrograms_trainingPrograms__69GKT","programHeader":"trainingPrograms_programHeader__UjmdV","programBody":"trainingPrograms_programBody__hA4ah"};